import React from 'react';
import './Features.css';

import { features } from '../../../constants';
import { Feature, Heading } from '../../../components';



const Features = () => {

  return (
    <section className='features'>

      {/* Section heading */}
      <Heading title={'Our Features'} subTitle={'Explore Our Features'} />

      {/* Container for feature items */}
      <div className="box-container">

        {/* Map through the features and render each feature */}
        {features.map((feature) => (
          <Feature key={feature.id} feature={feature} />
        ))}

      </div>

    </section>
  );
}

export default Features;